export default [
  {
    path: "statistics",
    name: "statistics",
    redirect: { name: "admin:statistics:statistics" },
    component: (): Promise<any> => import(/* webpackChunkName: "admin:statistics" */ "@/views/Admin/StatisticView.vue"),
    children: [
      {
        path: "statistics",
        name: "statistics",
        component: (): Promise<any> =>
          import(/* webpackChunkName: "admin:statistics:statistics" */ "@/components/Admin/Statistic/Statistic.vue")
      },
      {
        path: "detailing",
        name: "detailing",
        component: (): Promise<any> =>
          import(/* webpackChunkName: "admin:statistics:detailing" */ "@/components/Admin/Statistic/Detailing.vue")
      },
      {
        path: "analytic",
        name: "analytic",
        component: (): Promise<any> =>
          import(/* webpackChunkName: "admin:statistics:analytic" */ "@/components/Admin/Statistic/Analytic.vue")
      },
      {
        path: "analyticsTargetAudience",
        name: "analyticsTargetAudience",
        component: (): Promise<any> =>
          import(/* webpackChunkName: "admin:statistics:analyticsTargetAudience" */ "@/components/Common/Statistic/AnalyticTargetAudience/AnalyticTargetAudience.vue")
      },
      {
        path: "trafficAnalysis",
        name: "trafficAnalysis",
        component: (): Promise<any> =>
          import(/* webpackChunkName: "admin:statistics:trafficAnalysis" */ "@/components/Common/Statistic/TrafficAnalysis.vue")
      },
      {
        path: "landingsHistory",
        name: "landingsHistory",
        component: (): Promise<any> =>
          import(/* webpackChunkName: "admin:statistics:landingsHistory" */ "@/components/Admin/Statistic/LandingsHistory.vue")
      },
      {
        path: "domonetization",
        name: "domonetization",
        component: (): Promise<any> =>
          import(/* webpackChunkName: "admin:statistics:domonetization" */ "@/components/Admin/Statistic/Domonetization.vue")
      },
      {
        path: "registrations",
        name: "registrations",
        component: (): Promise<any> =>
          import(/* webpackChunkName: "admin:statistics:domonetization" */ "@/components/Admin/Statistic/Registrations.vue")
      }
    ]
  }
];
